var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrameDiff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_589_3386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 3,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    fill: "#0BB83C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11L15.1076 15.6123L15.1097 15.614C15.7878 16.1113 16.1271 16.3601 16.4988 16.4562C16.8272 16.5412 17.1725 16.5412 17.501 16.4562C17.8729 16.36 18.2132 16.1105 18.8926 15.6123C18.8926 15.6123 22.8101 12.6059 25 11M8 20.8002V13.2002C8 12.0801 8 11.5196 8.21799 11.0918C8.40973 10.7155 8.71547 10.4097 9.0918 10.218C9.51962 10 10.0801 10 11.2002 10H22.8002C23.9203 10 24.4796 10 24.9074 10.218C25.2837 10.4097 25.5905 10.7155 25.7822 11.0918C26 11.5192 26 12.079 26 13.1969V20.8036C26 21.9215 26 22.4805 25.7822 22.9079C25.5905 23.2842 25.2837 23.5905 24.9074 23.7822C24.48 24 23.921 24 22.8031 24H11.1969C10.079 24 9.5192 24 9.0918 23.7822C8.71547 23.5905 8.40973 23.2842 8.21799 22.9079C8 22.4801 8 21.9203 8 20.8002Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 3.5,
    stroke: "#DEDFE5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_589_3386"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameDiff);
export default __webpack_public_path__ + "static/media/FrameDiff.3a89d202f37de955641dfb2a3c96d1a7.svg";
export { ForwardRef as ReactComponent };